import React from 'react';
import { Button } from '@bytebrand/fe-ui-core-autobahn/ui';
import { IconSVG } from '@bytebrand/fe-ui-core-autobahn/iconsvg';
import { supportEmail, supportPhone } from '../../../framework/constants/app';
// import GrayPhoneIcon from '../../ui/SVG/GrayPhoneIcon';
// import GrayEnvelopeIcon from '../../ui/SVG/GrayEnvelopeIcon';
import styles from './modals.styl';
const OfferRequestThanksModal = ({ t, hideModal }) => {
    // useEffect(() => {
    //   if (!!hotjar) hotjar.event('OFFER_REQUEST_THANKS_MODAL');
    // }, []);  // eslint-disable-line
    const onCloseClick = () => {
        hideModal('OFFER_REQUEST_THANKS_MODAL');
    };
    return (React.createElement("div", { className: `${styles.modal} ${styles.thxModal}` },
        React.createElement("div", { className: styles.content },
            React.createElement("div", { className: styles.modalContent },
                React.createElement("p", { className: styles.text }, t('modals:offerRequest.thanksMessage')),
                React.createElement("div", { className: styles.axel, style: { width: 156, height: 175 } })),
            React.createElement("div", { className: styles.flexWrapper },
                React.createElement("div", { className: styles.contactItem },
                    React.createElement(IconSVG, { name: 'contactPhone', customDimensions: true, className: styles.contactIcon }),
                    React.createElement("div", { className: styles.contactContent },
                        React.createElement("div", { className: styles.contactTitle }, t('modals:offerRequest.carConsultation')),
                        React.createElement("div", { className: styles.contactText }, supportPhone))),
                React.createElement("div", { className: styles.contactItem },
                    React.createElement(IconSVG, { name: 'contactEmail', customDimensions: true, className: styles.contactIcon }),
                    React.createElement("div", { className: styles.contactContent },
                        React.createElement("div", { className: styles.contactTitle }, t('modals:offerRequest.contactEmail')),
                        React.createElement("div", { className: styles.contactText }, supportEmail))))),
        React.createElement("div", { className: styles.controls },
            React.createElement(Button, { className: styles.btnLink, variant: 'outlined', onClick: onCloseClick }, t('modals:offerRequest.backToVehicle')))));
};
export default OfferRequestThanksModal;
